import formIdReducer, { formIdReducers } from "./form-id-state"
import { IProductFormActionTypesAndValues } from "../_actions"
import combineReducers, {
  Action,
  Reducer,
  StateFromReducersMapObject,
} from "../../../utils/combine-reducer"
import { IDropdownOption } from "./_utils/product-form-types"

const loading = (
  state: number = 0,
  action: Action<IProductFormActionTypesAndValues>
): number => {
  switch (action.type) {
    case "START_FORM_LOADING":
    case "START_FORM_SUBMITTING":
      return 1
    case "UPDATE_DECLINATION_OPTIONS":
    case "STORE_PRODUCT":
    case "STOP_FORM_LOADING":
    case "STOP_FORM_SUBMITTING":
      return 0
    default:
      return state
  }
}

const submitting = (
  state: number = 0,
  action: Action<IProductFormActionTypesAndValues>
): number => {
  switch (action.type) {
    case "START_FORM_SUBMITTING":
      return state + 1
    case "STOP_FORM_SUBMITTING":
      return state - 1
    default:
      return state
  }
}

const declinationList = (
  state: IDropdownOption[] = [],
  action: Action<IProductFormActionTypesAndValues>
): IDropdownOption[] => {
  switch (action.type) {
    case "UPDATE_DECLINATION_LIST":
      return action.value
    default:
      return state
  }
}

const declinationOptions = (
  state: IDropdownOption[] = [],
  action: Action<IProductFormActionTypesAndValues>
): IDropdownOption[] => {
  switch (action.type) {
    case "UPDATE_DECLINATION_OPTIONS":
      return action.value
    default:
      return state
  }
}

export interface IDataByFormId<T> {
  [formId: string]: T
}

const dataByFormId = (
  state: IDataByFormId<StateFromReducersMapObject<formIdReducers>> = {},
  action: Action<IProductFormActionTypesAndValues>
): IDataByFormId<StateFromReducersMapObject<formIdReducers>> => {
  if (action.type === "CLOSE_FORM_ID" && action.formId) {
    delete state[action.formId]
    return { ...state }
  } else if (action.type === "RESET_FORM_ID" && action.formId) {
    return {
      ...state,
      [action.formId]: formIdReducer(undefined, action),
    }
  } else if (action.formId) {
    return {
      ...state,
      [action.formId]: formIdReducer(state[action.formId], action),
    }
  }
  return state
}

const reducers = {
  loading,
  declinationOptions,
  declinationList,
  dataByFormId,
  submitting,
}

export type ProductFormState = StateFromReducersMapObject<typeof reducers>

export default combineReducers<typeof reducers>({ ...reducers })
